module.exports = __webpack_public_path__ + "static/img/SensorHost_2x3.897cbaf2.webp";